import React, { ReactElement } from 'react';

const HoldAlertIcon = (): ReactElement => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="32" viewBox="0 0 36 32" fill="none">
      <path
        d="M0 31.0345L17.9673 0L35.9347 31.0345H0ZM17.9673 26.1343C18.4301 26.1343 18.8181 25.9778 19.1311 25.6647C19.4442 25.3516 19.6007 24.9637 19.6007 24.5009C19.6007 24.0381 19.4442 23.6502 19.1311 23.3371C18.8181 23.024 18.4301 22.8675 17.9673 22.8675C17.5045 22.8675 17.1166 23.024 16.8035 23.3371C16.4905 23.6502 16.3339 24.0381 16.3339 24.5009C16.3339 24.9637 16.4905 25.3516 16.8035 25.6647C17.1166 25.9778 17.5045 26.1343 17.9673 26.1343ZM16.3339 21.2341H19.6007V13.0672H16.3339V21.2341Z"
        fill="#DD0B24"
      />
    </svg>
  );
};

export default HoldAlertIcon;
